module.exports = __webpack_public_path__ + "static/media/feature-2-structured.9ce00641.png";